import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

const PublicRoute = () => {
  const { authToken } = useAuth()

  if (authToken) {
    return <Navigate to="/home" replace={true} />
  }

  return <Outlet />
}

export default PublicRoute
